import React from 'react'
import { MdLaunch } from 'react-icons/md'

import { Box, Flex, Link, Text } from '../system'
import BoxWithBorder from '../box-with-border'
import { getTextColor } from '../../utils/color'

const ColorValue = ({ label, inverted, value, href }) => (
  <Box mt={4} px={2} css={{ flexShrink: 0, flexBase: '50%' }}>
    <Text
      color={inverted ? 'white.700' : 'black.700'}
      fontFamily="brand"
      fontSize={1}
    >
      {label}
    </Text>
    <Flex alignItems="center">
      <Text fontSize={1} css={{ whiteSpace: 'nowrap' }}>
        {value}
        {href && (
          <>
            {' '}
            <Link href={href} color={inverted ? 'white.800' : 'black.800'}>
              <MdLaunch style={{ marginLeft: '0.25rem' }} />
            </Link>
          </>
        )}
      </Text>
    </Flex>
  </Box>
)

const ColorSwatch = ({ color, ...rest }) => {
  const textColor = getTextColor(color.contrast)
  const inverted = textColor === 'white.900'

  return (
    <BoxWithBorder
      width={{ md: 1 / 3 }}
      py={4}
      px={2}
      {...rest}
      bg={color.hex}
      color={textColor}
      withBorder={!inverted}
    >
      <Text fontFamily="brand" fontSize={4} px={2} fontWeight={1}>
        {color.name}
      </Text>
      <Flex flexWrap="wrap">
        <ColorValue value={color.hex} label="HEX" inverted={inverted} />
        <ColorValue
          label="RGB"
          inverted={inverted}
          value={`${color.rgb.r} ${color.rgb.g} ${color.rgb.b} `}
        />
        {color.pms && (
          <ColorValue
            label="PMS"
            inverted={inverted}
            value={color.pms.value}
            href={color.pms.href}
          />
        )}
        {color.cmyk && (
          <ColorValue
            label="CMYK"
            inverted={inverted}
            value={color.cmyk.value}
          />
        )}
      </Flex>
    </BoxWithBorder>
  )
}

export default ColorSwatch
